// Activity tab. Per-member audit history stacked together — same shape
// as the legacy modal's Activity tab, reusing AuditHistory.
//
// The Overview tab already shows a top-10 recent activity feed across
// the whole household; this tab gives the full history broken out by
// member so you can scroll any one person's edits in isolation.

import AuditHistory from '../../common/AuditHistory';

export default function ActivityTab({ household, members, people }) {
  // Combine all entities whose changes we want to surface for this
  // household: the household record itself, every person, and every
  // engagement (client row). Each gets its own collapsible audit list.
  const sections = [];

  sections.push({
    key: `hh-${household.id}`,
    title: `Household: ${household.name}`,
    table: 'households',
    recordId: household.id,
  });

  for (const p of people) {
    sections.push({
      key: `person-${p.id}`,
      title: `Person: ${p.name}`,
      table: 'people',
      recordId: p.id,
    });
  }

  for (const m of members) {
    sections.push({
      key: `client-${m.id}`,
      title: `Engagement: ${m.name} (${(m.division || '').toUpperCase()})`,
      table: 'clients',
      recordId: m.id,
    });
  }

  return (
    <div className="bg-white rounded-[4px] shadow-[0_2px_6px_rgba(0,0,0,0.07)] p-5">
      <div className="mb-4">
        <h2 className="text-[15px] font-bold text-navy">Activity History</h2>
        <p className="text-[11px] text-[#888] mt-0.5">
          {sections.length} record{sections.length === 1 ? '' : 's'} tracked across this household.
          The Overview tab shows the most recent 10 events firm-wide; this tab is the per-record drilldown.
        </p>
      </div>

      <div className="space-y-5">
        {sections.map(s => (
          <div key={s.key}>
            <div className="text-[11px] uppercase tracking-wider text-deep-teal font-bold mb-1.5">
              {s.title}
            </div>
            <AuditHistory table={s.table} recordId={s.recordId} limit={10} />
          </div>
        ))}
      </div>
    </div>
  );
}
